// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3DKX_","tab":"Tabs_tab__csnW-","tabActive":"Tabs_tabActive__OU425"};